import(/* webpackMode: "eager" */ "/src/src/app/(staitc-page)/terms-conditions/pc.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/terms-conditions/TermsContent.client.tsx");
;
import(/* webpackMode: "eager" */ "/src/src/app/(staitc-page)/terms-conditions/wap.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
